/**
 * @author Fabio Mora <famora@ebay.com>
 */
export default class ClickToShow {

    /**
     * @param element
     * @param gtm
     */
    constructor(element, gtm = {trackEvent() {}}) {
        this.prefix = 'click-to-show';
        this.dataSelector = `[data-${this.prefix}]`;
        this.unrevealedClass = 'unrevealed';
        this.$element = $(element);
        this.gtm = gtm;

        if (this.$element.hasClass(this.unrevealedClass)) {
            return;
        }

        this.$element.addClass(this.prefix);
        this.contents = this.$element.html() || '';
        this.$element.data('contents', this.contents);

        this.re = new RegExp(this.$element.data(`${this.prefix}-replace-pattern`) || '[^0-9+\\s]+', 'g');
        this.maxChars = this.$element.data(`${this.prefix}-max-chars`) || 7;
        this.maskChars = this.$element.data(`${this.prefix}-mask`) || '***';
        this.label = this.$element.data(`${this.prefix}-label`) || 'Mostra numero';

        this.control = `<span class="control">
                            <span class="control__mask">${this.maskChars}</span>
                            <span class="control__label">${this.label}</span>
                       </span>`;
    }

    /**
     * Hide the content
     */
    mask() {

        if (!this.contents || !this.contents.length) {
            return;
        }

        let shortContent = this.contents.replace(this.re, '');
        shortContent = shortContent.trim();
        shortContent = shortContent.substring(0, this.maxChars);
        shortContent = shortContent.trim();
        shortContent = `<span class="number">${shortContent}</span>`;

        this.$element
            .addClass(this.unrevealedClass)
            .html(`${shortContent}${this.control}`);
    }

    /**
     * Reveal the hidden content and stops the event bubbling
     *
     * @param e jQuery.Event
     */
    reveal(e) {
        let $target = $(e.target).closest(this.dataSelector).first();

        if (!$target.hasClass(this.unrevealedClass)) {
            return;
        }

        $target
            .removeClass(`${this.unrevealedClass} ${this.prefix}`)
            .html($target.data('contents'));

        this.gtm.trackEvent('R2SPhoneBegin', $target.data('extraparam'));
    }
}
